import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountCloseSuccessPage} from 'features/credit/pages/CreditAccountClosePage/CreditAccountCloseSuccessPage';

export const Route = createFileRoute(
  '/_protected/accounts/credits/$accountId/close/success',
)({
  component: CreditAccountCloseSuccessPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      action: search.action as string | undefined,
    };
  },
});
